import errors_en_gb from './errors/errors_en-gb'
import base_en_gb from './base/base_en-gb'
import buttons_en_gb from './buttons/buttons_en-gb'
import headers_en_gb from './headers/headers_en-gb'
import labels_en_gb from './labels/labels_en-gb'
import messages_en_gb from './messages/messages_en-gb'
import readings_en_gb from './readings/readings_en-gb'
import categories_en_gb from './categories/categories_en-gb'
import configurations_en_gb from './configurations/configurations_en-gb'

import errors_fr from './errors/errors_fr'
import base_fr from './base/base_fr'
import buttons_fr from './buttons/buttons_fr'
import headers_fr from './headers/headers_fr'
import labels_fr from './labels/labels_fr'
import messages_fr from './messages/messages_fr'
import readings_fr from './readings/readings_fr'
import categories_fr from './categories/categories_fr'
import configurations_fr from './configurations/configurations_fr'

import errors_pt from './errors/errors_pt'
import base_pt from './base/base_pt'
import buttons_pt from './buttons/buttons_pt'
import headers_pt from './headers/headers_pt'
import labels_pt from './labels/labels_pt'
import messages_pt from './messages/messages_pt'
import readings_pt from './readings/readings_pt'
import categories_pt from './categories/categories_pt'
import configurations_pt from './configurations/configurations_pt'

export default {
	'en-gb': {
		...errors_en_gb,
		...base_en_gb,
		...buttons_en_gb,
		...headers_en_gb,
		...labels_en_gb,
		...messages_en_gb,
		...readings_en_gb,
		...categories_en_gb,
		...configurations_en_gb
	},
	fr: {
		...errors_fr,
		...base_fr,
		...buttons_fr,
		...headers_fr,
		...labels_fr,
		...messages_fr,
		...readings_fr,
		...categories_fr,
		...configurations_fr
	},
	pt: {
		...errors_pt,
		...base_pt,
		...buttons_pt,
		...headers_pt,
		...labels_pt,
		...messages_pt,
		...readings_pt,
		...categories_pt,
		...configurations_pt
	}
}



// WEBPACK FOOTER //
// ./src/i18n/index.js